import React from "react";
import ReactSelect from "react-select";
import apiClient from '../../../../utils/apiClient';

const validationColor = {
  control: (styles) => ({
    ...styles,
    borderLeftColor: "red",
    borderLeftWidth: "4px",
    borderRadius: "0",
  })
};

const customStyles = {
  control: (styles) => ({
    ...styles,
    fontSize: '13px',
  }),
  option: (provided) => ({
    ...provided,
    fontSize: '13px', // Adjust the font size as needed
  })
};  

export default class MultiSelectDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      values: [],
      isMulti: props.isMulti ?? false,
      optionsSelected: null,
      loadUrl: props.loadUrl,
      filterIsEnabledOnly: props.filterIsEnabledOnly ?? true,
      idsSelected: props.idsSelected ?? null,
      idColumnName: props.idColumnName,
      validation: true,
      isRendering: false
    };
  }
  componentDidMount() {
    if (this.state.loadUrl) {
      if (this.props.onLoadingStart) {
        this.props.onLoadingStart();
      }
      this.setState({ isRendering: true });
      apiClient.get(this.state.loadUrl) 
        .then((response) => {
          const data = response.data;
          if (data) {
            let values = data
              .filter(
                (i) =>
                  i.isEnabled || !this.state.filterIsEnabledOnly ||
                  (this.state.idsSelected != null &&
                    this.state.idsSelected.filter(
                      (y) => y == i[this.state.idColumnName]
                    ).length > 0)
              )
              .map((item) => {
                return {
                  label: item.name,
                  value: item[this.state.idColumnName],
                  isEnabled: item.isEnabled,
                };
              });

            this.setState({ values: values });
            if (this.state.idsSelected != null) {
              const filtered = values.filter((obj) => {
                return this.state.idsSelected.includes(obj.value);
              });

              this.setState({
                optionsSelected: filtered,
              });
            }
          }
        }).catch((error) => {
          if (error === 'Unauthorized') {
            return; // Exit the componentDidMount function
          }
          console.error(error);
        })
        .finally(() => {
          this.setState({ isRendering: false });
      });
    }
  }
  
  setOptions = (options, idsSelected = null) => {
    // Update state if idsSelected is provided
    if (idsSelected) {
      this.setState({ idsSelected });
    }

    if (options) {
      // Determine which options should be displayed
      const values = options
        .filter((item) =>
          item.isEnabled || !this.state.filterIsEnabledOnly ||
          (this.state.idsSelected && this.state.idsSelected.includes(item.criteriaId))
        )
        .map((item) => ({
          label: item.name,
          value: item.criteriaId,
          isEnabled: item.isEnabled,
        }));

      // Update available options
      this.setState({ values });

      // If there are selected IDs, filter them for display as selected options
      const currentIdsSelected = idsSelected || this.state.idsSelected;
      if (currentIdsSelected) {
        const filtered = values.filter((obj) =>
          currentIdsSelected.includes(obj.value)
        );

        this.setState({
          optionsSelected: filtered,
        });
      }
    }
  };

  reloadTheDd(url, criteriaData, withids = false) {
    if (this.props.onLoadingStart) {
      this.props.onLoadingStart();
    }
    this.setState({ isRendering: true });

    apiClient.post(url, criteriaData)
      .then((response) => {
        const data = response.data;
        let values = data
          .filter(
            (i) =>
              i.isEnabled || !this.state.filterIsEnabledOnly ||
              (this.state.idsSelected != null &&
                this.state.idsSelected.filter(
                  (y) => y == i[this.state.idColumnName]
                ).length > 0)
          )
          .map((item) => {
            return {
              label: item.name,
              value: item[this.state.idColumnName],
              isEnabled: item.isEnabled,
            };
          });

        this.setState({ values: values });

        if (withids) {
          this.setIds();
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.setState({ isRendering: false });
      });
  }

componentDidUpdate(prevProps, prevState) {
  if (prevState.isRendering && !this.state.isRendering) {
      if (this.props.onLoadingEnd) {
          this.props.onLoadingEnd();
      }
  }
}

  setIds() {
    if (this.state.idsSelected != null) {
      const filtered = this.state.values.filter((obj) => {
        return this.state.idsSelected.includes(obj.value);
      });

      this.setState({
        optionsSelected: filtered,
      });
    }
  }

  getSelectedOptions = () => {
    return this.state.optionsSelected;
  };

  handleChange = (selected) => {
    this.setState({
      optionsSelected: this.state.isMulti ? selected : Array.of(selected),
    });
    if (this.props.onChange) {
      this.props.onChange(selected);
    }    
  };

  getOptionsSelected = () => {
    return this.state.optionsSelected;
  };

  getValidation = () => {
    if (
      this.state.optionsSelected == undefined ||
      this.state.optionsSelected == [] ||
      !this.state.optionsSelected.length
    ) {
      this.setState({ validation: false });
    } else {
      this.setState({ validation: true });
    }
  };

  resetValues = () => {
    this.setState({ values: [] });
  };

  render() {
    const {customNoOptionsMessage } = this.props;
    const noOptionsMessage = () => {
      return customNoOptionsMessage || "No options";
    };
    return (
      <>
        <ReactSelect
          options={this.state.values}
          isMulti={this.state.isMulti}
          styles={!this.state.validation ? validationColor : customStyles}
          closeMenuOnSelect={!this.state.isMulti}
          onChange={this.handleChange}
          value={this.state.optionsSelected}
          onMenuOpen={this.props.handleFilterCriteriaChange}
          className="custom-react-select"
          classNamePrefix={"react-select"}
          required
          defaultValue=""
          noOptionsMessage={noOptionsMessage}
          filterOption={(option, inputValue) =>
            option.label &&
            option.label.toLowerCase().includes(inputValue.toLowerCase())
          }            
        />
        {!this.state.validation && <p className="p-required">Required</p>}
      </>
    );
  }
}
